
import { TableRow, TableCell, TextField, Autocomplete, useTheme } from '@mui/material';
import { tokens } from '../../theme/theme';

const TableFilterRow = ({
    columns,
    filters,
    handleFilterChange,
    uniqueValues,
    autoCompleteColumns = [],
}) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <TableRow sx={{ backgroundColor: colors.primary[500] }}>
            {columns.map((col) => (
                <TableCell key={col} sx={{ padding: '4px' }}>
                    {autoCompleteColumns.includes(col) ? (
                        <Autocomplete
                            freeSolo
                            options={uniqueValues[col] || []}
                            fullWidth
                            // value={filters[col] || ''}
                            value={filters[col] ?? ""}
                            onInputChange={(event, newValue) =>
                                handleFilterChange({ target: { value: newValue } }, col)
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Filter"
                                    variant="standard"
                                    fullWidth
                                    InputProps={{
                                        ...params.InputProps,
                                        disableUnderline: true,
                                    }}
                                    sx={{
                                        fontSize: '0.75rem',
                                        borderRadius: 1,
                                        px: 1,
                                    }}
                                />
                            )}
                        />
                    ) : (
                        <TextField
                            variant="standard"
                            value={filters[col] || ''}
                            onChange={(e) => handleFilterChange(e, col)}
                            placeholder="Filter"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                            }}
                            sx={{
                                fontSize: '0.75rem',
                                borderRadius: 1,
                                px: 1,
                            }}
                        />
                    )}
                </TableCell>
            ))}
        </TableRow>
    );
};

export default TableFilterRow;
